// Central content store for Arya's portfolio.

export const PROFILE = {
  name: "Arya",
  fullName: "Arya Abhijit Kadulkar",
  role: "D365 Business Central Technical Consultant",
  location: "Mumbai | Bangalore",
  email: "aryakadulkar@gmail.com",
  phone: "+91 98338 48644",
  linkedin: "https://www.linkedin.com/in/arya-kadulkar",
  resumeUrl:
    "https://customer-assets-jt897jd0.emergentagent.net/job_arya-showcase-1/artifacts/ccccfda9d1e50fc5_Arya_Kadulkar_BC_Technical%20%281%29.pdf",
  resumeFilename: "Arya Kadulkar BC Developer.pdf",
  summary:
    "Business Central Technical Consultant with 3+ years of experience implementing and customising Dynamics 365 BC across manufacturing, finance, sales and warehouse operations — with a soft spot for well-crafted AL code, clean integrations and Power Platform automation.",
  connectMessage: "i am glad to connect",
};

export const EXPERIENCE = [
  {
    company: "ERBrains",
    role: "D365 Business Central Technical Consultant",
    period: "Jul 2025 — Present",
    location: "Bangalore, India",
    blurb:
      "Delivering end-to-end Business Central implementations across Sales, Purchase, Warehouse, Production, Project and Gate Entry modules — including custom Purchase Requisition and Quality Control flows.",
    highlights: [
      "Integrated Business Central with Azure, banking, accounting and CRM systems for automated cross-system data flow.",
      "Led Navision-to-Business Central object upgrades, converting legacy objects into BC-compatible extensions.",
      "Shipped fixes and customisations across 6+ concurrent support projects spanning finance, sales, purchase and manufacturing.",
      "Built and customised 30+ RDLC and Excel reports with multi-level grouping for finance and manufacturing teams.",
      "Designed and delivered technical training for a new Technical Consultant covering Business Central architecture, AL programming, customization, reports, pages, codeunits, and development best practices — resulting in project readiness.",
    ],
    tags: ["AL", "Business Central", "Integrations", "RDLC"],
  },
  {
    company: "CocoonIT Services",
    role: "Business Central Technical Consultant",
    period: "Aug 2023 — Jun 2025",
    location: "Mumbai, India",
    blurb:
      "Delivered 4 full implementations plus integration, upgrade, REST API and multi-project support engagements across Manufacturing, Finance, Purchase, Sales, Production and Services modules.",
    highlights: [
      "Developed multi-level RDLC reports for Sales, Purchase, Finance and Manufacturing departments.",
      "Supported BC deployments on-cloud and on-premises, including NAV 2016 and Power Platform environments.",
      "Integrated Business Central with Power Apps, eshopaid and Outlook.",
    ],
    tags: ["REST API", "NAV Upgrade", "Power Platform", "Support"],
  },
];

export const PROJECTS = [
  {
    id: "01",
    title: "Expense Manager",
    category: "Power Apps · Internal Tool",
    year: "2024",
    description:
      "An internal expense management app built end-to-end in Power Apps. Role-based approvals for managers and admins, advance-amount handling, and review workflows that fire from inside the app or straight from Outlook & Teams.",
    image:
      "https://images.unsplash.com/photo-1604782666037-3c63d50052db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "02",
    title: "BC Implementation Suite",
    category: "Business Central · Full Rollouts",
    year: "2023 — Present",
    description:
      "Multiple end-to-end Business Central rollouts covering Sales, Purchase, Warehouse, Production, Project and Gate Entry — plus custom Purchase Requisition and Quality Control processes tailored to each client.",
    image:
      "https://images.unsplash.com/photo-1638657527755-ca3e0d217260?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "03",
    title: "NAV → BC Upgrade",
    category: "Migration · AL Extensions",
    year: "2024",
    description:
      "Object-level upgrade from legacy Navision to Business Central — converting C/AL objects into clean, maintainable AL extensions without breaking the customer's day-to-day operations.",
    image:
      "https://images.unsplash.com/photo-1745159338135-39f6b462b382?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const BLOGS = [
  {
    title: "Notes from a BC implementation",
    date: "Coming soon",
    readTime: "—",
    excerpt:
      "Field notes from real Business Central rollouts — the parts the documentation doesn't tell you.",
    url: "https://arya.blogspot.com",
  },
  {
    title: "AL for humans",
    date: "Coming soon",
    readTime: "—",
    excerpt:
      "A friendly walkthrough of AL patterns I keep reaching for — written the way I wish someone had explained them to me.",
    url: "https://arya.blogspot.com",
  },
  {
    title: "NAV → BC without tears",
    date: "Coming soon",
    readTime: "—",
    excerpt:
      "The upgrade playbook I lean on: what to convert, what to rewrite, and what to quietly leave behind.",
    url: "https://arya.blogspot.com",
  },
];

export const EDUCATION = [
  {
    school: "Thadomal Shahani Engineering College",
    degree: "B.E. — Electronics & Telecommunication",
    period: "2019 - 2023",
    note: "Graduated Jun 2023 with a GPA of 8.25/10.",
  },
];

export const SKILLS = [
  "AL",
  "C/AL",
  "Business Central",
  "Navision",
  "REST API",
  "Integrations",
  "Power Apps",
  "Power Automate",
  "Azure",
  "SharePoint",
  "Postman",
  "RDLC Reports",
];

export const PHOTOS = {
  portrait:
    "https://customer-assets-jt897jd0.emergentagent.net/job_arya-showcase-1/artifacts/a0fb8515fa162ef5_FB9F4D1E-ACD7-4AC9-B950-AC25D31652B6_1_102_a.webp",
  ladakh:
    "https://customer-assets-jt897jd0.emergentagent.net/job_arya-showcase-1/artifacts/dr2t3i1j_9DD0CC71-3726-47A9-92FB-03B1693FAA8A.jpeg",
  snow:
    "https://customer-assets-jt897jd0.emergentagent.net/job_arya-showcase-1/artifacts/lntmysan_BA3DBADF-E771-4892-856C-181DC9EA9BA4_4_5005_c.jpeg",
};

export const CERTIFICATIONS = [
  {
    name: "Mastering Microsoft Power Apps 2024 — From Zero to Hero",
    issuer: "Udemy",
  },
];

export const ABOUT_CHAPTERS = [
  {
    number: "01",
    title: "Who is Arya",
    body:
      "Arya is a Business Central technical consultant who loves the quiet craft of good code. Three years in, she has shipped implementations, integrations and upgrades across manufacturing, finance, sales and warehouse teams — and still gets a small thrill from a clean AL extension and a report that groups exactly the way the client asked.",
  },
  {
    number: "02",
    title: "Where she is from",
    body:
      "Mumbai raised her — Thadomal Shahani Engineering College, an Electronics & Telecommunication degree, and a city that taught her to move fast and stay curious. Bangalore is where the work happens now: ERBrains, deeper problems, bigger rollouts and a new kind of quiet.",
  },
  {
    number: "03",
    title: "Where she wants to go",
    body:
      "Toward work that lasts. Arya is building a career around Dynamics 365 and the Power Platform — the boring, brilliant systems that quietly run businesses. Long term: architect-level consulting, more writing, and the occasional side project that reminds her why she started.",
  },
];

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Experience", path: "/experience" },
  { label: "Projects", path: "/projects" },
  { label: "Education", path: "/education" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const ARTSY_NAV_LINKS = [
  { label: "Home", path: "/handmade" },
  { label: "Experience", path: "/handmade/experience" },
  { label: "Projects", path: "/handmade/projects" },
  { label: "Education", path: "/handmade/education" },
  { label: "About", path: "/handmade/about" },
  { label: "Contact", path: "/handmade/contact" },
];
